<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account', 'organizationSiteGroups']),
  },

  methods: {
    getRoutinePermissions({ routine, routineDefinition, approvals } = {}) {
      return useCases.routines.getPermissions({
        routine,
        routineDefinition,
        approvals,
        currentAccount: this.account,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },
  },
}
</script>
